// extracted by mini-css-extract-plugin
export default {"UserAvatar":"UserAvatar_UserAvatar__C00b2"};